module.exports = __webpack_public_path__ + "static/media/tree_white.8bfadbc2.png";